module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-6@3x.ver2_0_2.jpg?f00a64dd";